import React, { useState } from 'react'
import AttendanceTodayList from './AttendanceTodayList'
import AttendanceActions from './AttendanceActions'
import AttendanceLeaveTodayList from './AttendanceLeaveTodayList'

export default function AttendanceManager() {
    const [activeTab, setActiveTab] = useState('attendance') // 'attendance' or 'leave'

    return (
        <div className="page-container min-h-screen flex flex-col lg:flex-row">
            {/* Left Container with Tab Header */}
            <div className="lg:w-1/2 w-full bg-gray-100 p-4">
                {/* Tabs */}
                <div className="flex flex-wrap gap-3 mb-4">
                    <button
                        onClick={() => setActiveTab('attendance')}
                        className={activeTab === 'attendance' ? 'btn-primary' : 'btn-secondary'}
                    >
                        Attendance Today
                    </button>
                    <button
                        onClick={() => setActiveTab('leave')}
                        className={activeTab === 'leave' ? 'btn-primary' : 'btn-secondary'}
                    >
                        Leave Today
                    </button>
                </div>

                {/* Conditional Content */}
                {activeTab === 'attendance' && <AttendanceTodayList />}
                {activeTab === 'leave' && <AttendanceLeaveTodayList />}
            </div>

            {/* Right Container */}
            <div className="lg:w-1/2 w-full bg-white p-4">
                <AttendanceActions />
            </div>
        </div>
    )
}
